/* RepeatDayOfWeekOfMonthComponent.js */

"use strict";
const Renderer = require("./RepeatDayOfWeekOfMonthRenderer");
const BaseScheduleComponent = require("../../base/BaseScheduleComponent");

class RepeatDayOfWeekOfMonthComponent extends BaseScheduleComponent {
    constructor(scheduleComp) {
        super(Renderer, scheduleComp);
    }
    setDefaultScheduleType(type, wasSetByUser) {
        super.setSchedule(RepeatDayOfWeekOfMonthComponent.defaultValue(type), wasSetByUser);
    }
    static defaultValue() {
        let now = new Date();
        return {
            type: "dowom",
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
            every: 1,
            dowc: 1,
            dow: 2,
            time: {
                hour: 12,
                minute: 0,
            },
            start: {
                year: now.getFullYear(),
                month: now.getMonth(),
                date: now.getDate(),
            },
        };
    }
}
module.exports = RepeatDayOfWeekOfMonthComponent;
